/**
 * Attribute that opts one shortcode instance into server-rendering its flow.
 *
 * Kept in its own module, free of the `'use client'` directive, so the server
 * enrichment in `index.tsx` and the client adapter can both import it without
 * pulling the adapter's module graph into the server bundle.
 */
export const SERVER_RENDER_ATTR = 'server-render';

const TRUTHY = ['true', '1', 'yes'];

/**
 * Server-rendering is opt-in. An absent, empty, or unrecognized value keeps the
 * instance on the client fetch path.
 */
export function isServerRenderEnabled(raw?: string): boolean {
  return typeof raw === 'string' && TRUTHY.includes(raw.trim().toLowerCase());
}

/**
 * What `data-server-rendered` reports: whether the first step is in the initial
 * HTML. Nothing more — an instance that never opted in and one whose prefetch
 * came back empty both read `false`, and the `server-render` attribute in the
 * CMS already says which of the two it was. Matches `DeFlowExperience`.
 */
export function serverRenderedAttr(seeded: boolean): 'true' | 'false' {
  return seeded ? 'true' : 'false';
}
